import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FraudRulesEffects } from './effects/fraud-rules.effects';
import { cartReducer } from './reducer/cart.reducer';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature('cart', cartReducer), EffectsModule.forFeature([FraudRulesEffects])],
})
export class CartModule {}
